<template lang="pug">
div.control-container
  .control-panel(v-if="hiddenControl()" :class="`${parentClass}`")
    .filter1.filters
      //- Ícono para mostrar el panel del menu izquierdo
      .mobile-menu-btn
        v-btn.mobile-menu(v-show="isMapView || isInProjectsView" fab flat small color='primary' @click='toggleMenuVisible()' style='z-index: 402; position: inherit')
          span.ap-menu

      //- input para realizar busquedas
      .search-control-container.input-without-line(v-if="isMobile")
        v-text-field.search-input(placeholder="Buscar" v-model="search")

      //- Ícono para filtro de años
      div
        v-tooltip(v-model="tooltipControls" right)
          template(#activator="{ on }")
            v-btn(v-on="on" depressed fab color="primary" :flat="!controlWithUIPanel.controls" @click.stop="toggleControlAndCloseTooltipAndOtherPanels('controls')")
              i.ap-Controles
          span Controles

      //- Ícono para mostrar los filtros
      div
        v-tooltip(v-model="tooltipFilter" right)
          template(#activator="{ on }")
            v-btn(v-on="on" depressed fab color="primary" :flat="!controlWithUIPanel.filter" :disabled="!visibility.filter" @click.stop="toggleControlAndCloseTooltipAndOtherPanels('filter')")
              i.ap-filter
          span Filtros

      //- Ícono para mostrar la lista de proyectos
      div
        v-tooltip(v-model="tooltipProjectList" right)
          template(#activator="{ on }")
            v-btn(v-on="on" depressed fab color="primary" :flat="!controlWithUIPanel.projectList" :disabled="!visibility.projectList" @click.stop="toggleControlAndCloseTooltipAndOtherPanels('projectList')")
              i.ap-projects-list
          span Lista de Proyectos

      //- Ícono para mostrar el resumen de refugios
      div(v-if="visibility.refugioPanel")
        v-tooltip(v-model="tooltipRefugioPanel" right)
          template(#activator="{ on }")
            v-btn(v-on="on" depressed fab color="primary" :flat="!state.refugioPanel" @click.stop="toggleControlAndCloseTooltip('refugioPanel')")
              i.ap-info
          span Panel de Datos de Albergues

      //- Ícono para mostrar el resumene, ayuda, header y footer
        div
          v-tooltip(v-model="tooltipMovileView" right)
            template(#activator="{ on }")
              v-btn(v-on="on" depressed fab color="primary" :flat="!state.movileView" :disabled="!visibility.movileView" @click.stop="toggleControlAndCloseTooltip('movileView')")
                i.ap-info
            span Informaciones

      //- Ícono para imprimir la pantalla
      div(v-if="!isMobile")
        v-tooltip(v-model="tooltipPrintScreen" right)
          template(#activator="{ on }")
            v-btn(v-on="on" depressed fab flat color="primary" @click.stop="print()")
              i.ap-print
          span Imprimir pantalla

  v-navigation-drawer.primary.mobile-menu-drawer(v-model="menuVisible" dark absolute temporary style="z-index: 10999; position: fixed;")
    v-list.pt-0(v-if="hrefify")
      template(v-for="item in navigationDrawerList")
        v-list-tile(to :href="hrefify(item.link)" :class="{ 'v-list__tile--active': item.active }" v-if="item.conditional" @click="toggleMenuVisible()")
          v-list-tile-content
            v-list-tile-title {{ item.title }}

  SearcherList(@clearSearch="search=''" v-if="isMobile")

  transition(name="fade")
    #asu-controls-sidebar(v-show="!!asuControlUIPanel")
      v-btn(icon @click.stop="closeControlAndResetUIPanel()" style="position: absolute; right: 0; top: 0; z-index: 1000")
        i.material-icons clear

      div(v-if="controlWithUIPanel.controls" style="overflow-y: scroll; height: 69vh;")
        ControlCota(v-if="!isInProjectsView")

        .buttons(v-if="!isInProjectsView")
          .asu-title
            span.asu-title Controles

          //- Ícono para mostrar los shapes o markers
          v-tooltip(v-model="tooltipShapes" bottom v-if="visibility.shapes")
            template(#activator="{ on }")
              v-btn(v-on="on" depressed fab color="primary" :flat="!state.shapes" :class="state.shapes ? 'active': isMapView ? 'deactive':''" @click.stop="toggleControlAndCloseTooltip('shapes')")
                i.ap-shape
            span Áreas de proyectos

          //- Ícono para instituciones
          v-tooltip(v-model="tooltipInstituciones" bottom v-if="visibility.instituciones")
            template(#activator="{ on }")
              v-btn(v-on="on" depressed fab color="primary" :flat="!state.instituciones" @click.stop="toggleControlAndCloseTooltip('instituciones')")
                i.ap-institucion-afectada
            span Instituciones

          //- Ícono para refugios
          v-tooltip(v-model="tooltipRefugios" bottom v-if="visibility.refugios")
            template(#activator="{ on }")
              v-btn(v-on="on" depressed fab color="primary" :flat="!state.refugios" @click.stop="toggleControlAndCloseTooltip('refugios')")
                i.ap-Refuge
            span Albergues

        ControlYear(v-if="state.shapes")

      FilterPanel
      ProjectListPanel(v-if="controlWithUIPanel.projectList")

</template>

<script>
import L from 'leaflet'
import { mapActions, mapGetters, mapState } from 'vuex'
import resize from '@/mixins/resize.js'
import mapChildMixin from '@/mixins/map-child.js'
import { setTimeout } from 'timers'

const homeViewObj = { name: 'home' }

export default {
  name: 'ControlPanel',
  mixins: [ resize, mapChildMixin ],
  components: {
    ProjectListPanel: _ => import('@/components/participa/ProjectListPanel'),
    FilterPanel: _ => import('./FilterPanel'),
    ControlYear: _ => import('./ControlYear'),
    ControlCota: _ => import('./ControlCota'),
    SearcherList: _ => import('@/components/utils/SearcherList')
  },
  mounted () {
    let initialState = !window.isMobile
    this.tooltipsActive = !window.isMobile
    this.tooltipFlood = initialState
    this.tooltipShapes = initialState
    this.tooltipLabels = initialState
    this.tooltipFilter = initialState
    this.tooltipProjectList = initialState
    this.tooltipRefugios = initialState
    this.tooltipRefugioPanel = initialState
    this.tooltipMovileView = initialState
    this.tooltipControls = initialState
    this.tooltipInstituciones = initialState
    this.tooltipPrintScreen = initialState
    if (initialState) {
      setTimeout(() => {
        this.tooltipFlood = false
        this.tooltipShapes = false
        this.tooltipLabels = false
        this.tooltipFilter = false
        this.tooltipProjectList = false
        this.tooltipRefugios = false
        this.tooltipRefugioPanel = false
        this.tooltipMovileView = false
        this.tooltipControls = false
        this.tooltipInstituciones = false
        this.tooltipPrintScreen = false
      }, 5000
      )
    }
    this.updateByPath()
    if (this.lmapObject) {
      this.asuControlsSidebar = L.control.sidebar('asu-controls-sidebar', {
        position: 'left',
        autoPan: false
      })
      this.lmapObject.addControl(this.asuControlsSidebar)
    }
  },
  data () {
    return {
      asuControlsSidebar: null,
      menuVisible: false,
      search: '',
      tooltipFlood: false,
      tooltipShapes: false,
      tooltipRefugioPanel: false,
      tooltipMovileView: false,
      tooltipLabels: false,
      tooltipFilter: false,
      tooltipProjectList: false,
      tooltipRefugios: false,
      tooltipControls: false,
      tooltipInstituciones: false,
      tooltipsActive: true,
      tooltipPrintScreen: true
    }
  },
  methods: {
    ...mapActions([
      'toggle',
      'showControl',
      'hideControl',
      'activateControl',
      'desactivateControl',
      'toggleControlWithUIPanel',
      'closeControlAndResetUIPanel',
      'setSearchText'
    ]),

    hiddenControl () {
      return this.isInProjectsView || this.isMapView || this.isSolucionACortoPlazo || this.isSolucionDefinitiva
    },

    showSearchList () {
      return (this.search !== '' && this.search.trim().length > 0)
    },

    toggleControlAndCloseTooltip (control) {
      // this[`tooltip${capitalize(control)}`] = false
      this.toggle(control)
    },

    toggleControlAndCloseTooltipAndOtherPanels (control) {
      // this[`tooltip${capitalize(control)}`] = false;
      this.toggleControlWithUIPanel(control)
    },

    toggleMenuVisible () {
      this.menuVisible = !this.menuVisible
    },

    togglePanelInfoByResize (isMobile) {
      if (isMobile) {
        this.activateControl('movileView')
      }
    },

    updateByPath () {
      if (/map/.test(this.path)) {
        this.showControl('refugios')
        this.showControl('instituciones')
      } else {
        this.hideControl('refugios')
        this.hideControl('instituciones')
        this.desactivateControl('refugios')
      }
    },

    print () {
      window.print()
    }

  },
  computed: {
    ...mapGetters([
      'hrefify',
      'isMapView',
      'asuControlUIPanel',
      'controlWithUIPanel',
      'isCurrentRoute',
      'isSolucionACortoPlazo',
      'isSolucionDefinitiva',
      'isInProjectsView'
    ]),
    ...mapGetters({
      state: 'interfaceState',
      visibility: 'interfaceVisibility',
      filter: 'projectsFilter'
    }),
    ...mapState('route', {
      path: state => state.fullPath
    }),
    navigationDrawerList () {
      const projectsViewObj = { name: 'projects' }
      return [
        {
          link: homeViewObj,
          title: 'Inicio',
          conditional: this.isMobile,
          active: this.isHomeView
        },
        {
          link: projectsViewObj,
          title: 'Proyectos',
          conditional: this.isMobile,
          active: this.isCurrentRoute(projectsViewObj)
        },
        {
          link: { name: 'map' },
          title: 'Solución definitiva',
          conditional: this.isMobile,
          active: this.isSolucionDefinitiva
        },
        {
          link: { name: 'map', query: { ver: 'refugios' } },
          title: 'Solución a corto plazo',
          conditional: this.isMobile,
          active: this.isSolucionACortoPlazo
        }
      ]
    },
    parentClass () {
      let clas = this.isMapView ? 'MapView' : ''
      clas += this.visibility.instituciones ? ' instituciones-visible' : ''
      clas += this.isMobile ? ' show-mobile-controls' : ''
      return clas
    }
  },
  watch: {
    isMobile (newValue) {
      this.togglePanelInfoByResize(newValue)
    },
    path () {
      this.updateByPath()
    },
    asuControlUIPanel (val) {
      if (!this.asuControlsSidebar) return
      if (val) {
        this.asuControlsSidebar.show()
      } else {
        this.asuControlsSidebar.hide()
      }
    },
    getSearchText () {
      this.search = this.getSearchText
    },
    search (newValue) {
      this.setSearchText(newValue)
    }
  }
}
</script>

<style scoped lang="stylus">
.isMobile
  .buttons
    margin-left: 20px !important

@import '~@/styles/variables'

$toggle-button-font-size = $f25px

@media screen and (max-width: 850px)
  .isMobile
    .control-panel
      align-items: center
      background: white
      border: 2px solid darkgray
      border-radius: 10px
      display: flex
      width: 89%
      .filter1
        width: 100%
        .mobile-menu-btn
          display: flex
          align-items: center
          outline: none
          .v-btn:before
            height: auto
          .mobile-menu
            margin: 10px
            position: inherit !important
            cursor: pointer
    .control-container
      display: flex !important
      justify-content: center

.control-panel
  color: $color_0
  background-color: rgba(255, 255, 255, .85)
  position: absolute
  top: 0
  bottom: 0
  z-index: 401
  transition-property: transform height
  transition-duration: 0.5s
  transform: "translateY(%s)" % $header-height
  will-change: transform height
  height: "calc(100vmax - %s)" % ($header-height)
  height: "calc(100vh - %s)" % ($header-height)
  @media print
    display: none
  .isMobile &
    height: 10vh
    top: -65px
    .filter1
      display: flex
      flex-direction: row
    .search-control-container
      display: flex
      flex-grow: 1
      .search-input
        margin: 10px
        outline: none
        font-family: 'Raleway'
        width: 100%

  .filters
    img, i
      cursor: pointer
      height: auto
  .filter1
    text-align: center
    img
      width: 100%

.control-container
  .selected
    font-weight: bold

  .v-btn
    i
      font-size: $f25px

  // Estilos para la página de projects y NO DEL MAPA
  #asu-controls-sidebar
    position: absolute
    background-color: white
    padding: $f7px $f10px
    top: $header-height
    left: 72px
    z-index: 1
    width: $f500px
    @media print
      display: none
    @media screen and (min-width: 768px) and (max-width: 850px)
      margin-top: 1px
      left: auto
      height: 80vh
      max-width: 89vw;
      min-width: 500px
      left: auto !important;
      width: 89% !important;
      margin: auto;
      top: 12vh !important;
      z-index: 1000 !important;
      border: 2px solid #a9a9a9;
      border-top: 0;
      border-radius: 0 0 20px 20px;
      height: 80vh;
    @media screen and (max-width: 768px)
      margin-top: 1px
      left: auto
      max-width: 89vw;
      left: auto !important;
      width: 89% !important;
      margin: auto;
      top: 12vh !important;
      z-index: 1000 !important;
      border: 2px solid #a9a9a9;
      border-top: 0;
      border-radius: 0 0 20px 20px;
      height: 80vh;
    @media screen and (max-width: 768px) and (orientation: landscape)
      height: 70vh;
      top: 20vh !important;
    @media screen and (max-width: 812px)  and (max-height: 375px) and (orientation: landscape)
      height: 70vh !important;
      top: 20vh !important;

.project-list-panel
  @media screen and (max-width: 812px)  and (max-height: 375px) and (orientation: landscape)
    height: auto !important;

.fade-enter-active, .fade-leave-active
  transition-property: opacity transform
  transition-duration: 0.5s
  opacity: 1
  transform: "translateX(- %s)" % $f500px
  will-change: opacity transform

.fade-enter, .fade-leave-to
  opacity: 0
  transform: translateX(0)

@media print
  .v-tooltip__content
    display: none

</style>

<style lang="stylus">
@import '~@/styles/variables'

#asu-controls-sidebar
  .buttons
    .v-btn
      i
        font-size: $f25px

.input-without-line
  .v-text-field > .v-input__control > .v-input__slot:before
    border-style: hidden !important;

  .v-text-field > .v-input__control > .v-input__slot
    margin: 0 !important

</style>
